import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-296de3c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common_layout" }
const _hoisted_2 = { style: {"padding-left":"32px","padding-right":"32px"} }
const _hoisted_3 = {
  class: "common_font",
  style: {"font-size":"16px","font-weight":"bolder","margin-top":"38px","text-align":"center"}
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { style: {"margin-top":"97px"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "common_font",
  style: {"color":"#a8abb2","font-weight":"normal"}
}, "修改密碼", -1))
const _hoisted_7 = { style: {"margin-top":"15px"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "common_font",
  style: {"color":"#a8abb2","font-weight":"normal"}
}, "退出", -1))

import { reactive, onMounted, getCurrentInstance, ref, onBeforeUnmount } from "vue";
import { get, post } from "../utils/request";
import { useRouter } from "vue-router";
import { Encrypt } from "../utils/secret";
import QRCode from "qrcodejs2";

export default /*#__PURE__*/_defineComponent({
  __name: 'managerHome',
  setup(__props) {

const router = useRouter();
const { proxy }: any = getCurrentInstance();
const account = reactive({ value: "" });
const topManageButton = reactive({ value: [] });
const qrshow = ref(false);
const qrcodeRef = ref(null);
onMounted(() => {
	getAccountInfo();
});

const getAccountInfo = () => {
	get("/get/information", {})
		.then((res) => {
			// console.log(JSON.stringify(res));
			if (res.code === 1) {
				let roleType = res.result.role;
				localStorage.setItem("role", res.result.role);
				localStorage.setItem("userId", res.result.id);
				account.value = res.result.username;
				if (roleType === "MANAGEMENT") {
					topManageButton.value = [
						{ name: "子賬號管理", type: "child" },
						{ name: "訂單管理", type: "order" },
						{ name: "商品管理", type: "goods" },
					];
				} else {
					topManageButton.value = [
						{ name: "創建訂單", type: "createOrder" },
						{ name: "直接生成付款二維碼", type: "toQR" },
						{ name: "查看訂單", type: "viewOrer" },
					];
				}
			}
		})
		.catch((error) => {
			console.log(error);
		});
};

const manageAction = (data) => {
	// console.log(data);
	if (data.type === "child") {
		router.push("/childManage");
	} else if (data.type === "goods") {
		router.push("/goodsManage");
	} else if (data.type === "createOrder") {
		router.push("/BuildPages");
	} else if (data.type === "viewOrer") {
		router.push("/orderManage");
	} else if (data.type === "order") {
		router.push("/orderManage");
	} else if (data.type === "toQR") {
		console.log(qrcodeRef.value);
		qrcodeRef.value.getshow();
	}
};

const changePassRoute = () => {
	router.push("/changePassword");
};
const openMessageBox = () => {
	proxy
		.$showDialog({
			title: "提示",
			message: "是否退出登录？",
		})
		.then(() => {
			// on confirm
			outLogin();
		})
		.catch(() => {
			// on cancel
		});
};

const outLogin = () => {
	let loginToken = localStorage.access_token;

	post(`/auth/logout?accessToken=${loginToken}`, {}, null)
		.then((res) => {
			// console.log(JSON.stringify(res));
			if (res.code === 1) {
				proxy.$toast("退出成功");
				router.push("/");
			}
		})
		.catch((error) => {
			console.log(error);
		});
};

return (_ctx: any,_cache: any) => {
  const _component_TopHeader = _resolveComponent("TopHeader")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Qrcode = _resolveComponent("Qrcode")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_TopHeader, { title: "首頁" }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, " Hi，" + _toDisplayString(account.value), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topManageButton.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            style: _normalizeStyle({ marginTop: index === 0 ? '38px' : '15px' }),
            onClick: ($event: any) => (manageAction(item)),
            class: "manage_list_item"
          }, _toDisplayString(item.name), 13, _hoisted_4))
        }), 128)),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            style: {"width":"100%","border-radius":"2px"},
            size: "large",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (changePassRoute()))
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_button, {
            style: {"width":"100%","border-radius":"2px"},
            size: "large",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (openMessageBox()))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_Qrcode, {
      ref_key: "qrcodeRef",
      ref: qrcodeRef
    }, null, 512)
  ], 64))
}
}

})